/* Should never contain any specific JavaScript functions */

const cache = {};

var importAll = (request) => {
    request.keys().forEach((key) => (cache[key] = request(key)));
};

importAll(require.context('./Components', true, /\.(js|ts)$/));